import React from 'react';
import RcTooltip from 'rc-tooltip';
import styles from './tooltip.module.css';
import 'rc-tooltip/assets/bootstrap.css';
import { cssVar } from '@cad-arc';

type RcTooltipProps = React.ComponentProps<typeof RcTooltip>;

export function Tooltip(props: {
    overlay: React.ReactNode;
    children: React.ReactElement;
    mouseEnterDelay?: RcTooltipProps['mouseEnterDelay'];
    mouseLeaveDelay?: RcTooltipProps['mouseLeaveDelay'];
    placement?: RcTooltipProps['placement'];
}): JSX.Element {
    return props.overlay ? (
        <RcTooltip
            destroyTooltipOnHide={{ keepParent: false }}
            overlayStyle={{
                zIndex: cssVar('arc.zIndices.tooltip'),
                color: cssVar('arc.colors.text.primary'),
            }}
            placement={props.placement ?? 'bottom'}
            overlayClassName={styles['mark43-tooltip']}
            mouseLeaveDelay={props.mouseLeaveDelay ?? 0}
            {...props}
            mouseEnterDelay={props.mouseEnterDelay ?? 0.1}
        />
    ) : (
        <>{props.children}</>
    );
}
